import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as appHelper from '../../../helpers/appHelper';
import * as objectConstants from '../../../constants/objectConstants';

class PrototypeLearnerSpeak extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {

            you_label: appHelper.getLocaleString("you_label"),
        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(nextProps) {

    }

    componentDidUpdate() {

    }

    render() {
        return (
            <div className={`object-container`}>
                <div className="user_name_label prototype">
                    <span>{this.state.you_label}</span>
                </div>
                <div className={`prototype learner speak`} dangerouslySetInnerHTML={{__html: objectConstants.PROTOTYPE_LEARNER_SPEAK_TEXT}}/>
            </div>
        );
    }
}

PrototypeLearnerSpeak.propTypes = {
    locale: PropTypes.object,
};

PrototypeLearnerSpeak.contextTypes = {
    router: PropTypes.object
};

function mapStateToProps(state, ownProps) {
    return {};

}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(Object.assign({}, {}), dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(PrototypeLearnerSpeak);



/** WEBPACK FOOTER **
 ** ./src/components/objects/prototypeObjects/PrototypeLearnerSpeak.js
 **/